export const emptyDashboard = () => ({
  summary: {
    contractAmount: 0,
    fundAmount: 0,
    invoiceAmount: 0,
    outstandingAmount: 0,
    uninvoicedAmount: 0,
    signedContractAmount: 0,
    signedReceivedAmount: 0,
    signedInvoiceAmount: 0,
    historicalImportedInvoiceAmount: 0,
    businessInvoiceAmount: 0,
    reportYearBusinessInvoiceAmount: 0,
    contractCount: 0,
    signedContractCount: 0,
    mixedCategoryContractCount: 0,
    fallbackCategoryContractCount: 0
  },
  ledgerRows: [],
  ledgerTotal: 0,
  contractMonthlyRows: [],
  fundMonthlyRows: [],
  invoiceMonthlyRows: [],
  businessInvoiceMonthlyRows: [],
  invoiceCumulativeRows: [],
  personalFundRows: [],
  outstandingDepartmentRows: [],
  contractYearOptions: [],
  departmentOptions: [],
  productCategoryOptions: []
})

export function amount (value) {
  return Number(value || 0).toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

export function sumMonths (rows) {
  const months = Array.from({ length: 12 }, () => 0)
  ;(rows || []).forEach(row => {
    ;(row.monthAmounts || []).forEach((value, index) => {
      if (index < months.length) months[index] += Number(value || 0)
    })
  })
  return months
}

export function groupTotals (rows, field) {
  const values = {}
  ;(rows || []).forEach(row => {
    const key = row[field] || '未归属'
    values[key] = (values[key] || 0) + Number(row.totalAmount || 0)
  })
  return Object.keys(values).map(name => ({ name, value: values[name] }))
    .sort((left, right) => right.value - left.value)
}

export function buildFinanceRisks (dashboard) {
  const risks = []
  ;(dashboard.ledgerRows || []).forEach(row => {
    if (Number(row.contractStatus) !== 80) return
    const contractAmount = Number(row.contractAmount || 0)
    const receivedAmount = Number(row.receivedAmount || 0)
    const invoiceAmount = Number(row.invoiceAmount || 0)
    const base = {
      contractId: row.contractId,
      contractNum: row.contractNum,
      contractName: row.contractName,
      customerName: row.customerName,
      departmentName: row.departmentName,
      assignUserName: row.assignUserName
    }
    if (receivedAmount > contractAmount + 0.01) {
      risks.push(Object.assign({}, base, {
        level: 'danger', riskType: '超额回款',
        amount: receivedAmount - contractAmount,
        description: '累计回款超过合同金额，请复核合同变更或回款归属。'
      }))
    }
    if (invoiceAmount > contractAmount + 0.01) {
      risks.push(Object.assign({}, base, {
        level: 'danger', riskType: '超额开票',
        amount: invoiceAmount - contractAmount,
        description: '累计开票超过合同金额，请复核发票归属或合同有效金额。'
      }))
    }
    if (receivedAmount > invoiceAmount + 0.01) {
      risks.push(Object.assign({}, base, {
        level: 'warning', riskType: '回款高于开票',
        amount: receivedAmount - invoiceAmount,
        description: '累计回款高于累计开票，供财务核对是否存在待开票事项。'
      }))
    }
    if (invoiceAmount > receivedAmount + 0.01) {
      risks.push(Object.assign({}, base, {
        level: 'warning', riskType: '开票高于回款',
        amount: invoiceAmount - receivedAmount,
        description: '累计开票高于累计回款，供财务关注后续回款。'
      }))
    }
    if ((row.productCategoryBasis || '').indexOf('历史合同无构成') >= 0) {
      risks.push(Object.assign({}, base, {
        level: 'info', riskType: '产品待归类', amount: contractAmount,
        description: '历史合同没有产品构成，当前暂按工程及服务等统计。'
      }))
    }
  })
  const order = { danger: 1, warning: 2, info: 3 }
  return risks.sort((left, right) => {
    const levelDiff = (order[left.level] || 9) - (order[right.level] || 9)
    return levelDiff || Number(right.amount || 0) - Number(left.amount || 0)
  })
}
